module.exports = __webpack_public_path__ + "c0ed932afe838287a6946541a0c81edf.MP3";